import './widgets.scss';
import React from 'react';
import { useSelector } from 'react-redux';
import { getTotalCreditBalance } from 'researcher/user/reducer';
import PreferredGroupWidget from './PreferredGroupWidget';
// import ReferralsWidget from './ReferralsWidget';
import PrepaymentAndCreditsWidget from './PrepaymentAndCreditsWidget';
// import RewardsWidget from './RewardsWidget';

var Widgets = function Widgets(_ref) {
  var addPreferredGroup = _ref.addPreferredGroup,
    companyShortName = _ref.companyShortName,
    removePreferredGroup = _ref.removePreferredGroup,
    user = _ref.user;
  var totalCreditBalance = useSelector(getTotalCreditBalance);
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    id: "widgets",
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 mb-1"
  }), user.hasRewards ? /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 mb-1"
  }) : null, !user.hasRewards && !user.hideInvoices && totalCreditBalance > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 mb-1"
  }, /*#__PURE__*/React.createElement(PrepaymentAndCreditsWidget, {
    companyShortName: companyShortName,
    currency: user.currency,
    totalCreditBalance: totalCreditBalance
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4 mb-1"
  }, /*#__PURE__*/React.createElement(PreferredGroupWidget, {
    addPreferredGroup: addPreferredGroup,
    removePreferredGroup: removePreferredGroup,
    companyShortName: companyShortName,
    currency: user.currency,
    preferredGroup: user && user.preferredGroup ? user.preferredGroup : null,
    userIdentity: user.identity
  }))));
};
export default Widgets;